import React from 'react';
import '../App.css';
import {
    Link
  } from "react-router-dom";

var title = { textAlign:'left', fontSize: "3.5em", marginTop: 80, color:'silver', fontWeight:"200", paddingLeft:70 }
var subTitle = { textAlign:'left', fontSize: "1.5em", marginTop: 30, color:'white', fontWeight:"200", paddingLeft:70, paddingRight:90 }

var windowSize = {
    display:"flex", flexDirection:'column',
    backgroundColor:'black', overflow:'scroll',
    width: "100vw", height: "auto", color: 'white', justifyContent: "end", alignItems:'left',
}

class About extends React.Component {
    constructor(props) {
        super(props);    
        this.state = {}
    }

render(){
    return(
        <div style={{ display:"flex", flexDirection:"row", height:"auto", backgroundColor:"red" }}>

        <div style={windowSize}>
            <h1 style={title}>    
            <span style={{color: "rgb(11, 232, 129)" }}>H</span>ello <span style={{color: "rgb(11, 232, 129)" }}>W</span>orld</h1>
           
            <img style={{ width: 150, height: 150, borderRadius: '50%', marginLeft:70  }} src="./creazerty_code.jpg" alt='creazerty' />

           <p style={subTitle}>
            My name is <span style={{color: "rgb(11, 232, 129)" }}>Fateh</span>,

            <br/>
            I am passionate about computer development and artificial intelligence.
            I learned to code on my own and then I signed up in October 2019 for a web and mobile web development bootcamp called <span style={{color: "rgb(11, 232, 129)" }}>La Caspule</span>.
            <br/>
            <br/>

            I learned a lot, but above all I learned to learn.
            Today, I am a project manager and I always learn more in my free time in order to develop my skills.
            <br/>
            <br/>

            I developed React Studio Code in order to offer help in component design without coding. Just by choosing the parameters offered by the studio.
            <br/>
            <br/>
            I will be happy to receive your ideas for improvements.
            The platform is in beta version, do not hesitate to inform me of any bugs encountered.
            <br />
            <br />
            See you soon for new web projects, thank you .
            <br/>
            <br/>


            <div style={{ marginTop: 40 }}>
            <form action="https://www.paypal.com/cgi-bin/webscr" method="post" target="_top">
            <input type="hidden" name="cmd" value="_donations" />
            <input type="hidden" name="business" value="9QKPMCTQD324N" />
            <input type="hidden" name="item_name" value="Pay me a coffee" />
            <input type="hidden" name="currency_code" value="EUR" />
            <input type="image" src="cupcake.png" border="0" name="submit" title="PayPal - The safer, easier way to pay online!" alt="Donate with PayPal button" width="280" />
            <img alt="" border="0" src="https://www.paypal.com/en_FR/i/scr/pixel.gif" width="1" height="1" />
            </form>
            </div>



            <div style={{display:'flex', flexDirection:'row'}}>
            
            <a href="https://twitter.com/creazerty" target='blank'><img style={{ width:40, height:40, marginTop:70, borderRadius:5, marginLeft:15 }} src='../twitter.png' alt="creazerty twitter" /></a>
            </div>

            </p>


            <p style={{ display:"flex", flexDirection:'column',position:'absolute', bottom:-10, right:40, fontWeight:"200", fontSize:14, color: "black", textDecoration:'none'}}>Developed by Creazerty</p>


            </div>

        </div>
    )
}

}

export default About;